import { render, staticRenderFns } from "./LifeEvent.vue?vue&type=template&id=645c2af7&scoped=true&"
import script from "./LifeEvent.vue?vue&type=script&lang=js&"
export * from "./LifeEvent.vue?vue&type=script&lang=js&"
import style0 from "./LifeEvent.vue?vue&type=style&index=0&id=645c2af7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645c2af7",
  null
  
)

export default component.exports